import React, { useEffect, useState } from "react";
import { getOrganisationData } from "../../api/Organisation";
import { useSelector, useDispatch } from "react-redux";
import { Menu, X, Bell, MapPin, ChevronDown } from "lucide-react";
import { Button, Form, Input } from "antd";
import { ToastContainer, toast } from "react-toastify";
import NoNotification from "../../../common/components/NoNotification";
import IMAGES from "../../../../constant/images";
import { isKycUsersOrgAdmin } from "../../../../utils/orgAccess";
export default function Index() {
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.getOrgData);
  const [logo, setLogo] = useState(null);
  const [name, setName] = useState(null);
  const [username, setUsername] = useState(null);
  const [userImage, setUserImage] = useState(
    "https://s3.ap-south-1.amazonaws.com/image.phyber.in/IMAGES/studen.jpg"
  );
  const [menuOpen, setMenuOpen] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showRoleSwitcher, setShowRoleSwitcher] = useState(false);
  const [currentRole, setCurrentRole] = useState("Admin");
  // const [notification, setNotification] = useState([])
  const [location, setLocation] = useState(null);
  const [route, setRoute] = useState([
    {
      slug: "dashboard",
      title: "Dashboard",
      path: "/dashboard",
      icon: IMAGES.dashboard_icon,
    },
    {
      slug: "members",
      title: "Members",
      path: "/members",
      icon: IMAGES.member_white,
    },
    {
      slug: "kyc_users",
      title: "KYC & Card Status",
      path: "/kyc-users",
      icon: IMAGES.reports_icon,
    },
    {
      slug: "practitioner",
      title: "Practitioners",
      path: "/practitioner",
      icon: IMAGES.white_practitioner,
    },
    {
      slug: "appointments",
      title: "Appointments",
      path: "/appointments",
      icon: IMAGES.white_appointment,
    },
    {
      slug: "events",
      title: "Events",
      path: "/calender",
      icon: IMAGES.white_event,
    },
    {
      slug: "company_wallet",
      title: "Company Wallet",
      path: "/company_wallet",
      icon: IMAGES.wallet_icon,
    },
    {
      slug: "store",
      title: "Store",
      path: "/store",
      icon: IMAGES.store_icon,
    },
    {
      slug: "analytics",
      title: "Analytics",
      path: "/analytics",
      icon: IMAGES.white_analytics,
    },
  ]);
  const [tools, setTools] = useState([
    {
      slug: "notification",
      title: "Notifications",
      path: "/notification",
      icon: IMAGES.white_noti,
    },
    {
      slug: "settings",
      title: "Settings & Users",
      path: "/settings",
      icon: IMAGES.white_settings,
    },
    {
      slug: "support",
      title: "Support & Tickets",
      path: "/support",
      icon: IMAGES.help_icon,
    },
  ]);
  const [notification, setNotification] = useState([
    // {
    //   type: "FOLLOW_UP",
    //   text: "Follow-up request accepted by Rahul Sharma.",
    //   time: "15m ago",
    // },
    // {
    //   type: "SCHEDULED",
    //   text: "Your event “Diabetes Care Webinar” is scheduled for tomorrow.",
    //   time: "15m ago",
    // },
    // {
    //   type: "FOLLOW_UP",
    //   text: "Follow-up request accepted by Rahul Sharma.",
    //   time: "30m ago",
    // },
    // {
    //   type: "SCHEDULED",
    //   text: "Your event “Diabetes Care Webinar” is scheduled for tomorrow.",
    //   time: "15m ago",
    // },
  ]);
  const getOrganisation = () => {
    dispatch(getOrganisationData()).then((res) => {
      if (res.payload.status === "success") {
        let update = res.payload.message.payload.forceUpdate;
        if (update === true) {
          // window.location.href = "/updateProfile";
        }

        setUserImage(res.payload.message.payload.imageURL);

        localStorage.setItem(
          "organisationId",
          res.payload.message.payload.organisationId
        );
        localStorage.setItem("email", res.payload.message.payload.email);
        setLocation(
          (res.payload?.message?.payload?.city || "Organisation") +
            ", " +
            (res.payload?.message?.payload?.state || " India")
        );
        localStorage.setItem("cid", res.payload.message.payload.pcUserId);
        localStorage.setItem(
          "orgName",
          res.payload.message.payload.organisationName
        );
        setName(res.payload.message.payload.organisationName);
        setLogo(res.payload.message.payload.organisationLogo);
        let title = res.payload?.message?.payload?.title || "Dr";
        setUsername(
          title +
            ". " +
            res.payload.message.payload.firstName +
            " " +
            res.payload.message.payload.lastName
        );

        localStorage.setItem(
          "practitioner_name",
          title +
            ". " +
            res.payload.message.payload.firstName +
            " " +
            res.payload.message.payload.lastName
        );
      }
    });
  };

  const getNotificationIcon = (type) => {
    if (type === "FOLLOW_UP") {
      return (
        <img alt={"FOLLOW_UP"} src={IMAGES.follow_up} className="w-8 h-8" />
      );
    } else if (type === "SCHEDULED") {
      return (
        <img
          alt={"SCHEDULED"}
          src={IMAGES.event_scheduled}
          className="w-8 h-8"
        />
      );
    }
  };

  useEffect(() => {
    getOrganisation();
    // Set current role from localStorage
    const userRole = localStorage.getItem("userRole");
    if (userRole === "ADMIN") {
      setCurrentRole("Admin");
    } else if (userRole === "CLIENT") {
      setCurrentRole("Member");
    }
  }, []);

  const isDisabledRoute = (path) => {
    return path === "/company_wallet" || path === "/store" || path === "/analytics" || path === "/notification";
  };

  const navigateItem = (path) => {
    setMenuOpen(!menuOpen);
    if (isDisabledRoute(path)) {
      // Do nothing for disabled routes
      return;
    } else if (path === "/") {
      toast.warning("Sorry this route is unavailable at the moment.");
    } else if (path === "/logout") {
      localStorage.clear();
      window.location.href = "/";
    } else {
      window.location.href = path;
    }
  };

  const handleRoleSwitch = (role) => {
    // Only allow switching from Admin to Member (one-way)
    if (role === "Member") {
      localStorage.setItem("userRole", "CLIENT");
      setCurrentRole("Member");
      setShowRoleSwitcher(false);
      // Redirect to member dashboard - AdminRoutes will redirect to /member/dashboard
      window.location.reload();
    }
  };

  return (
    <header className="fixed top-0 left-0 lg:left-[var(--sidebar-w,0px)] right-0 h-16 flex items-center py-2.5 px-4 md:px-8 border-b border-gray-200 shadow-xs justify-between font-poppins z-10 bg-white transition-all duration-300">
      {/* Left Section */}
      <div className="flex items-center space-x-3 md:w-[33%]">
        <Button
          className="block md:hidden bg-transparent border-0"
          onClick={() => setMenuOpen(true)}
        >
          <img
            alt="hamburger_menu"
            src={IMAGES.hamburger}
            className="w-7 h-7"
          />
        </Button>

        <a href="/dashboard">
          <img src={logo} alt="Phyber logo" className="h-8" />
        </a>
      </div>

      {/* Search - not wired to anything yet, hidden until it is */}
      {/* <div className="hidden md:flex flex-1 justify-center">
        <div className="w-full max-w-[320px] h-[38px]">
          <Input
            type="text"
            placeholder="Search"
            className="w-full !h-[35px] px-3 rounded-xl border-1 border-gray-200 shadow-sm focus:ring-2 focus:ring-phyber-200 text-gray-700 bg-white placeholder:text-gray-400 text-sm"
            prefix={
              <img
                alt="search_icon"
                src={IMAGES.search_icon}
                className="w-5 h-5"
              />
            }
          />
        </div>
      </div> */}
      <div className="hidden md:flex flex-1" />

      {/* Right Section */}
      <div className="flex items-center space-x-3">
        {/* Location */}
        <div className="hidden md:flex items-center space-x-2 bg-white border-[1px] border-solid border-gray-200 rounded-xl px-2 py-1 shadow-sm h-full">
          <img
            src={IMAGES.header_location}
            alt="location"
            className="w-[30px] h-[30px]"
          />
          <div className="flex-col">
            <span className="text-[10px] text-gray-400 font-semibold uppercase leading-none mb-0.5 block">{location}</span>
            <span className="text-xs font-semibold text-gray-800 leading-none block">
              {name}
            </span>
          </div>
        </div>

        {/* Notification */}
        <div className="h-6 w-px bg-gray-200/80 hidden md:block rounded-full" />

        <div className="relative flex items-center h-full">
          <Button
            onClick={() => setShowNotifications(!showNotifications)}
            className="bg-transparent border-0 p-0 h-[38px] w-[38px] rounded-full hover:bg-gray-100 transition-colors flex items-center justify-center"
          >
            <img
              src={IMAGES.header_notification}
              alt="notification"
              className="w-[38px] h-[38px]"
            />
          </Button>

          {showNotifications && (
            <div className="absolute top-10 right-0 w-[90vw] max-w-md bg-white shadow-xl border-[1px] border-solid border-gray-100 rounded-xl z-50 p-4">
              <div className="mb-2 flex justify-between items-center">
                <h3 className="text-lg font-semibold text-[#171717]">
                  Notification
                </h3>
                {notification.length > 0 && (
                  <button className="text-xs text-[#4B61FF] underline">
                    Mark all as read
                  </button>
                )}
              </div>
              <div className="border-t border-[#E2E8F0] my-2" />

              {notification.length > 0 ? (
                <>
                  <div className="bg-[#F1F5F9] px-3 py-1 text-base text-[#171717]">
                    Today
                  </div>
                  <div className="bg-white">
                    {notification.map((item, idx) => (
                      <div key={idx} className="flex space-x-3 py-2 border-b">
                        {getNotificationIcon(item.type)}
                        <div>
                          <p className="text-sm text-[#171717]">{item.text}</p>
                          <p className="text-xs text-[#334155]">{item.time}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="border-t border-[#E2E8F0] my-2" />
                  <div className="text-sm font-semibold text-[#171717] cursor-pointer">
                    View all notifications
                  </div>
                </>
              ) : (
                <NoNotification />
              )}
            </div>
          )}
        </div>

        {/* Profile */}
        <div className="flex items-center space-x-2 p-1.5 pr-3 rounded-full border-[1px] border-solid border-transparent hover:bg-phyber-50 hover:border-phyber-100 transition-all group">
          {/* Profile Picture - Clickable to /profile */}
          <a href="/profile">
            <img
              src={userImage}
              alt="profile"
              className="w-9 h-9 rounded-full object-cover cursor-pointer border-[1px] border-solid border-white shadow-sm"
            />
          </a>

          {/* Admin Name and Role Switcher */}
          <div className="hidden md:flex flex-col">
            <a
              href="/profile"
              className="block text-xs font-semibold text-gray-800 no-underline group-hover:text-phyber-700 transition-colors"
            >
              {username}
            </a>

            {/* Role Switcher Dropdown - Below admin name */}
            <div className="relative">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowRoleSwitcher(!showRoleSwitcher);
                }}
                className="inline-flex items-center gap-1 bg-phyber-50 rounded-full px-1.5 py-0.5 border-0 hover:bg-phyber-100 transition-colors"
              >
                <span className="text-[11px] text-phyber-700">{currentRole}</span>
                <ChevronDown size={12} className="text-phyber-700" />
              </button>

              {showRoleSwitcher && (
                <div className="absolute top-full mt-1 left-0 w-32 bg-white shadow-xl rounded-xl z-50 py-1 border-[1px] border-solid border-gray-100 overflow-hidden">
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRoleSwitch("Admin");
                    }}
                    className={`px-3 py-1.5 cursor-pointer hover:bg-[#F8FAFC] transition-colors ${
                      currentRole === "Admin" ? "bg-phyber-50 font-semibold" : ""
                    }`}
                  >
                    <span className="text-xs text-[#171717]">Admin</span>
                  </div>
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRoleSwitch("Member");
                    }}
                    className={`px-3 py-1.5 cursor-pointer hover:bg-[#F8FAFC] transition-colors ${
                      currentRole === "Member" ? "bg-phyber-50 font-semibold" : ""
                    }`}
                  >
                    <span className="text-xs text-[#171717]">Member</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {menuOpen && (
        <div className="fixed inset-0 z-[9999] flex">
          <div className="bg-white flex flex-col w-full h-full overflow-y-auto">
            <div className="min-h-screen bg-gradient-to-b from-blue-950 to-emerald-950 text-white flex flex-col justify-between">
              <div>
                <div className="p-4 flex justify-between items-center">
                  <div className="flex gap-2 items-center">
                    <img
                      src={IMAGES.location_mobile}
                      className="w-9 h-9"
                      alt="icon"
                    />
                    <div>
                      <span className="text-xs block">{location}</span>
                      <span className="font-semibold block">{name}</span>
                    </div>
                  </div>
                  <X
                    size={20}
                    className="cursor-pointer"
                    onClick={() => setMenuOpen(false)}
                  />
                </div>

                <div className="border-t border-white/10 my-2" />

                {/* Routes */}
                <div className="p-4 space-y-6">
                  {route.map((item, key) => {
                    if (item.slug === "kyc_users" && !isKycUsersOrgAdmin()) {
                      return null;
                    }
                    const disabled = isDisabledRoute(item.path);
                    return (
                      <div
                        key={key}
                        className={`flex items-center gap-3 ${
                          disabled
                            ? "cursor-not-allowed opacity-50"
                            : "cursor-pointer"
                        }`}
                        onClick={() => navigateItem(item.path)}
                      >
                        <img
                          src={item.icon}
                          alt={item.slug}
                          className="w-6 h-6"
                        />
                        <span className="text-sm">{item.title}</span>
                      </div>
                    );
                  })}
                </div>

                <div className="border-t border-white/10 my-2" />

                {/* Tools */}
                <div className="p-4">
                  <p className="text-xs mb-3">Tools</p>
                  <div className="space-y-6">
                    {tools.map((item, key) => {
                      const disabled = isDisabledRoute(item.path);
                      return (
                        <div
                          key={key}
                          className={`flex items-center gap-3 ${
                            disabled
                              ? "cursor-not-allowed opacity-50"
                              : "cursor-pointer"
                          }`}
                          onClick={() => navigateItem(item.path)}
                        >
                          <img
                            src={item.icon}
                            alt={item.slug}
                            className="w-6 h-6"
                          />
                          <span className="text-sm">{item.title}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="p-4 space-y-4">
                <div className="flex items-center">
                  <span className="text-sm">Powered by</span>
                  <img
                    src={IMAGES.footer_logo}
                    alt="footer_logo"
                    className="h-4 ml-1"
                  />
                </div>
                <div className="border-t border-white/10" />
                <div
                  className="flex items-center gap-3 cursor-pointer"
                  onClick={() => navigateItem("/logout")}
                >
                  <img
                    src={IMAGES.logout_icon}
                    alt="logout_icon"
                    className="w-6 h-6"
                  />
                  <span className="text-sm">Logout</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
